import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { StatusBar, Style } from '@capacitor/status-bar';
​
@Injectable({
   providedIn: 'root'
})
export class StatusbarService {
​
   constructor(
      private platform: Platform,
   ) { }
​
   /**
    * Establece el color de fondo del statusbar de un determinado color
    * Compatible solo con dispositivos Android
    * @param {string} color En formato hexadecimal
    */
   async setBackgroundColor(color: string) {
      if ( this.platform.is('android') && this.platform.is('hybrid') ) {
         await StatusBar.setBackgroundColor({ color: color })
      }
   }
   /**
    * Establece el color de texto del statusbar de color oscuro
    */
   async setTextDark() {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
​
      if ( !prefersDark.matches ) {
         await StatusBar.setStyle({ style: Style.Dark });
      }
   }
   /**
    * Establece el color de texto del statusbar de color claro
    */
   async setTextLight() {
      await StatusBar.setStyle({ style: Style.Light });
   }

   async arregloViewport() {
      await StatusBar.hide();
      await StatusBar.show();
   }

   async arregloCambioOrientacion() {
      await StatusBar.show();
      await StatusBar.hide();
   }
}
